import React from "react";
import DeleteModal from "../../Modal/DeleteModal";

export function CityDeleteModal({
  isLoadingDeleteCity,
  handleDeleteHide,
  isDeleteModal,
  onClickOfSaveButton,
}) {
  return (
    <>
      <DeleteModal
        isLoading={isLoadingDeleteCity}
        handleDeleteHide={handleDeleteHide}
        isDeleteModal={isDeleteModal}
        title={"City Delete"}
        message={"Are you sure to permanently delete this City?"}
        onClickOfSaveButton={onClickOfSaveButton}
        onClickOfCancelButton={handleDeleteHide}
        saveButtonLabel={"Delete"}
        cancelButtonLabel={"Cancel"}
      />
    </>
  );
}
